import React, { useState } from 'react';
import Field from '../../../../../modules/react/components/stateful/Field';
import RadioButtonsInput from '../../form/inputs/Radio/Radio';
import styles from './overlaySetting.scss';
import classes from './section.scss';
import ColorPickerInput from '../../form/inputs/ColorPicker/ColorPicker';


export const OPTION_NOOVERLAY = 'OVERLAY_NONE';
export const OPTION_BEHINDCONTENTAREA = 'BEHIND_CONTENT_AREA_OVERLAY';
export const OPTION_FULLOVERLAY = 'FULL_OVERLAY';


export const OPTION_COLOR = 'color';

export const COLOR_TRANSPARENT = 'transparent';

const radioOptions = {
  [OPTION_NOOVERLAY]: 'No Overlay',
  [OPTION_BEHINDCONTENTAREA]: 'Behind Content Area',
  [OPTION_FULLOVERLAY]: 'Full Overlay',
};
const radioImages = {
  [OPTION_NOOVERLAY]: { imgSrc: '/img/no-overlay.jpg', imgAlt: 'No Overlay' },
  [OPTION_BEHINDCONTENTAREA]: { imgSrc: '/img/overlay-behind-content.jpg', imgAlt: 'Behind content area' },
  [OPTION_FULLOVERLAY]: { imgSrc: '/img/full-overlay.jpg', imgAlt: 'Full Overlay' },
};

const additionalColors = [
  { value: '#f8f8f8', label: 'Light Grey' },
];

const OverlaySetting = ({ sectionStyle }) => {
  const [overlayType, setOverlayType] = useState(sectionStyle?.overlayType || OPTION_NOOVERLAY);

  const handleOverlayTypeChange = (e) => {
    setOverlayType(e.target.value);
  };

  const formatOverlayType = value => (value || OPTION_NOOVERLAY);

  return (
    <>
      <h4 className={classes.menuHeading}>Overlay Settings</h4>
      <div className={styles.overlaySettings}>
        <Field
          parentStyle={styles.radioButtons}
          label="Overlay Type"
          component={RadioButtonsInput}
          name="sectionStyle.overlayType"
          options={radioOptions}
          radioImages={radioImages}
          format={formatOverlayType}
          onChange={handleOverlayTypeChange}
          labelClassName={classes.fieldLabelClass}
          radioOptionsClass={classes.radioButtonOptions}
        />
        {overlayType !== OPTION_NOOVERLAY &&
          <Field
            label="Overlay Color"
            component={ColorPickerInput}
            name="sectionStyle.overlay"
            additionalColors={additionalColors}
            allowCustom
            labelClassName={classes.fieldLabelClass}
          />
        }
      </div>
    </>
  );
};

export default OverlaySetting;
